<template>
  <Page>
    <section aria-labelledby="not-found-title" class="flex flex-1 items-center justify-center p-6">
      <div class="w-full max-w-xl rounded-lg border border-border bg-background-card p-6 text-center">
        <i aria-hidden="true" class="fa-solid fa-question-circle mb-4 text-4xl text-text-muted" />
        <h1 id="not-found-title" class="mb-3 text-2xl font-semibold text-text">Page not found</h1>
        <p v-if="phase === 'resolving'" role="status" aria-live="polite" class="text-text-muted">
          Finding a place to continue…
        </p>
        <p v-else-if="phase === 'error'" role="alert" class="text-text-muted">{{ errorMessage }}</p>
        <p v-else role="status" aria-live="polite" class="text-text-muted">
          <template v-if="phase === 'redirecting'">Continuing to {{ destinationLabel }}.</template>
          <template v-else>Returning to {{ destinationLabel }} in 3 seconds.</template>
        </p>
        <div class="mt-6 flex justify-center gap-3">
          <template v-if="phase === 'error'">
            <Button label="Retry" @click="retry" />
            <Button label="Select project" severity="secondary" @click="selectProject" />
          </template>
          <Button
            v-else
            label="Continue now"
            :disabled="phase !== 'ready'"
            :loading="phase === 'redirecting'"
            @click="continueNow"
          />
        </div>
      </div>
    </section>
  </Page>
</template>

<script setup lang="ts">
import Button from 'primevue/button'
import Page from '@/shared/components/layouts/Page.vue'
import { useNotFoundRedirect } from '@/shared/composables/useNotFoundRedirect'

definePage({
  meta: {
    title: 'Page Not Found',
    requiresProject: false,
    notFound: true,
  },
})

const { phase, destinationLabel, errorMessage, continueNow, retry, selectProject } = useNotFoundRedirect()
</script>
